import React, { Component } from 'react'
import Profile from '../Profile'
import { Container } from './styles'
import users from '../../Data/users'

class ProfileGroup extends Component {
  render() {
    return(
      <Container>
      { users.map( (person, index) => <Profile
        key={index}
        name={person.name}
        avatar={person.avatar}
        url={person.url}
        username={person.username}
        seen={person.seen}
        anonymous={person.anonymous} />
      )}
    </Container>
    )
  }
}

export default ProfileGroup



// WEBPACK FOOTER //
// ./src/Components/ProfileGroup/index.js